// import { isNumeric } from "react-flow-renderer/dist/esm/utils"

const masterData = {
  months: [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" },
  ],
  years: [
    { id: 2017, name: "2017" },
    { id: 2018, name: "2018" },
    { id: 2019, name: "2019" },
    { id: 2020, name: "2020" },
    { id: 2021, name: "2021" },
    { id: 2022, name: "2022" },
    { id: 2023, name: "2023" },
    { id: 2024, name: "2024" },
    { id: 2025, name: "2025" },
    { id: 2026, name: "2026" },
    { id: 2027, name: "2027" },
    { id: 2028, name: "2028" },
    { id: 2029, name: "2029" },
    { id: 2030, name: "2030" },
  ],
  leaveCategories: [
    { id: 1, name: "Casual" },
    { id: 2, name: "Medical" },
  ],
  leaveApplicationStatuses: [
    { id: 1, name: "Pending" },
    { id: 2, name: "Approved" },
    { id: 3, name: "Rejected" },
    { id: 4, name: "Cancel" },
  ],
  jobStatuses: [
    { id: "published", name: "Open" },
    { id: "unpublished", name: "Closed" },
  ],
  jobEmploymentTypes: [
    { id: "contractual", name: "Contractual" },
    { id: "full_time", name: "Full Time" },
    { id: "part_time", name: "Part Time" },
    { id: "trainee", name: "Trainee" }
  ],
  jobApplicantStatus: [
    { id: 0, name: "Pending" },
    { id: 1, name: "Accepted" },
    { id: 2, name: "Rejected" },
  ],
  jobInterviewStatuses: [
    { id: "scheduled", name: "Scheduled" },
    { id: "selected", name: "Selected" },
    { id: "rejected", name: "Rejected" },
    { id: "candidate not available", name: "Candidate Not Available" },
    { id: "onboarded", name: "Onboarded" },
    { id: "on hold", name: "On Hold" },
    { id: "cancelled", name: "Cancelled" },
  ],
  holidayLocations: [
    { id: "kolkata", name: "Kolkata" },
    { id: "delhi", name: "Delhi" },
  ],
  usersType: [
    { id: "kolkata", name: "Admin" },
    { id: "Client", name: "Client" },
    { id: "delhi", name: "Staff" },
  ],
  userLocations: [
    { id: "kolkata", name: "Kolkata" },
    { id: "delhi", name: "Delhi" },
    { id: "bangalore", name: "Bangalore" },
  ],
  userFilter: [
    { id: "all", name: "All Employees" },
    { id: "active", name: "Active Employees" },
    { id: "deactive", name: "Inactive Employees" },
    { id: "department", name: "Department" },
  ],
  sortByFilter: [
    { id: "employeeName", name: "Employee Name" },
    { id: "joiningDate", name: "Date of Joining" },
  ],
  leaveStatusFilter: [
    { id: "all", name: "All Employees" },
    { id: "active", name: "Active Employees" },
    { id: "inactive", name: "Inactive Employees" },
  ],
  leaveCategory: [
    { id: "casual", name: "Casual" },
    { id: "medicalleave", name: "Medical Leave" },
  ],
  leaveDuration: [
    { id: "single_day", name: "Single day" },
    { id: "multiple_days", name: "Multiple days" },
    { id: "hours", name: "Hours" },
  ],
  leaveHours: [
    { id: "2", name: "0.25" },
    { id: "4", name: "0.5" },
    { id: "6", name: "0.75" },
  ],

  clockHistoryStatus: [
    { id: "1", name: "Pending" },
    { id: "2", name: "Approved" },
    { id: "3", name: "Rejected" },
  ],
  leaveSearchStatus: [
    { id: "all", name: "All" },
    { id: "pending", name: "Pending" },
  ],
  source: [
    { id: "website", name: "Website" },
    { id: "linkedIn", name: "LinkedIn" },
    { id: "indeed", name: "Indeed" },
    { id: "others", name: "Others" },
  ],
  work_location: [
    { id: "Work From Home", name: "Work From Home" },
    { id: "Work From Office", name: "Work From Office" },
    { id: "Remote", name: "Remote" },
  ],
  cvStatuses: [
    { id: "pending", name: "CV Feedback Pending", order: 1 },
    { id: "selected", name: "CV Shortlisted", order: 2 },
    { id: "rejected", name: "CV Rejected", order: 3 },
    { id: "documentation_initiated", name: "Documentation Initiated", order: 4 },
    { id: "documentation_rejected", name: "Documentation Rejected", order: 5 },
    { id: "offered", name: "Offered", order: 6 },
    { id: "offer_accepted", name: "Offer Accepted", order: 7 },
    { id: "offer_rejected", name: "Offer Rejected", order: 8 },
    { id: "not_interested", name: "Not Interested", order: 9 },
    { id: "on_hold", name: "On Hold", order: 10 },
    { id: 'onboarded', name: 'Joined', order: 11 },
    { id: 'not_joined', name: 'Not Joined', order: 12 },
    { id: 'not_responding', name: 'Not Responding', order: 13 },
    { id: 'interview_rejected', name: 'Interview Rejected', order: 14 },
    { id: 'interview_scheduled', name: 'Interview Scheduled', order: 15 },
    { id: 'interview_select', name: 'Interview Select', order: 16 },
    { id: 'ceo_round_select', name: 'CEO Round Select', order: 17 },
    { id: 'ceo_round_reject', name: 'CEO Round Reject', order: 18 },
    { id: 'hr_select', name: 'HR Select', order: 19 },
    { id: 'hr_reject', name: 'HR Reject', order: 20 },
    { id: '2nd_round_interview', name: '2nd Round Interview', order: 21 },
    { id: 'schedule_hr_round', name: 'Schedule HR Round', order: 22 },
    { id: 'technical_round1_feedback_pending', name: 'Technical Round 1 Feedback Pending', order: 23 },
    { id: 'technical_round2_feedback_pending', name: 'Technical Round 2 Feedback Pending', order: 24 },
    { id: 'mt_feedback_pending', name: 'MT Feedback Pending', order: 25 },
    { id: 'mt_select', name: 'MT Select', order: 26 },
    { id: 'mt_reject', name: 'MT Reject', order: 27 },
    { id: 'panel_no_show', name: 'Panel No show', order: 28 },
    { id: 'f2f_not_available', name: 'F2F not available', order: 29 },
    { id: 'hr_scheduled', name: 'HR Scheduled', order: 30 },
    { id: 'technical_round_1_selected', name: 'Technical Round 1: Selected', order: 31 },
    { id: 'technical_round_2_selected', name: 'Technical Round 2: Selected', order: 32 },

  ],



  officeTime: [
    { id: "everyday", name: "Every Day Same Time" },
    { id: "different", name: "Set Different Time" },
  ],
  days: [
    { id: 1, name: "Saturday" },
    { id: 2, name: "Sunday" },
    { id: 3, name: "Monday" },
    { id: 4, name: "Tuesday" },
    { id: 5, name: "Wednesday" },
    { id: 6, name: "Thursday" },
    { id: 7, name: "Friday" },
  ],
  gender: [
    { id: "Male", name: "Male" },
    { id: "Female", name: "Female" },
    { id: "Others", name: "Others" },
  ],
  documentCategory: [
    { id: "appointment_letter", name: "Appointment Letter" },
    // {id: 'offer_letter', name:'Offer Letter'},
  ],
  organizationCategory: [
    { id: "all", name: "All" },
    { id: "myself", name: "Myself" },
  ],
  feedbackMarks: [
    { id: 0, name: "0" },
    { id: 1, name: "1" },
    { id: 1.5, name: "1.5" },
    { id: 2, name: "2" },
    { id: 2.5, name: "2.5" },
    { id: 3, name: "3" },
    { id: 3.5, name: "3.5" },
    { id: 4, name: "4" },
    { id: 4.5, name: "4.5" },
    { id: 5, name: "5" },
    { id: 5.5, name: "5.5" },
    { id: 6, name: "6" },
    { id: 6.6, name: "6.5" },
    { id: 7, name: "7" },
    { id: 7.5, name: "7.5" },
    { id: 8, name: "8" },
    { id: 8.5, name: "8.5" },
    { id: 9, name: "9" },
    { id: 9.5, name: "9.5" },
    { id: 10, name: "10" },
    { id: -1, name: "NA" },
  ],

  assetAllocationStatus: [
    { id: 2, name: "All" },
    { id: 1, name: "Assign" },
    { id: 0, name: "Unassign" },
  ],
  arrAttendanceHeaderDropdown: [
    { id: "last_week", name: "Last Week" },
    { id: "month", name: "Month" },
    { id: "custom", name: "Custom Date" },
  ],

  arrDaysList: [
    { id: "Sunday", name: "S" },
    { id: "Monday", name: "M" },
    { id: "Tuesday", name: "T" },
    { id: "Wednesday", name: "W" },
    { id: "Thursday", name: "T" },
    { id: "Friday", name: "F" },
    { id: "Saturday", name: "S" },
  ],
  dateDutation: [
    { key: "Today", label: "Today" },
    { key: "Tomorrow", label: "Tomorrow" },
    { key: "In 2 business days", label: "In 2 business days" },
    { key: "In 3 business days", label: "In 3 business days" },
    { key: "In 1 week", label: "In 1 week" },
    { key: "In 2 weeks", label: "In 2 weeks" },
    { key: "In 1 month", label: "In 1 month" },
    { key: "In 3 months", label: "In 3 months" },
    { key: "In 6 months", label: "In 6 months" },
    { key: "Custom Date", label: "Custom Date" },
  ],
  reminderOptions: [
    { id: "No Reminder", label: "No Reminder" },
    { id: "At task due time", label: "At task due time" },
    { id: "30 minutes before", label: "30 minutes before" },
    { id: "1 hour before", label: "1 hour before" },
    { id: "1 day before", label: "1 day before" },
    { id: "1 week before", label: "1 week before" },
    { id: "Custom Date", label: "Custom Date" },
  ],
  meetingOutcomeList: [
    { id: 1, name: "Scheduled" },
    { id: 2, name: "Completed" },
    { id: 3, name: "Rescheduled" },
    { id: 4, name: "No Show" },
    { id: 5, name: "Canceled" },
  ],
  meetingDuration: [
    { id: 15, name: "15 Minutes" },
    { id: 30, name: "30 Minutes" },
    { id: 45, name: "45 Minutes" },
    { id: 60, name: "1 Hours" },
    { id: 90, name: "1.5 Hours" },
    { id: 120, name: "2 Hours" },
  ],
  ticketStatus: [
    { id: 'open', name: "Open" },
    { id: 'in_progress', name: "In Progress" },
    { id: 'closed', name: "Closed" },
  ],
  grade: [
    { id: 0, name: "0" },
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
  ],
  arrMenuDetails: [
    {
      id: [
        "/salary-configuration",
        "/payslip",
        "/investment-declaration",
        "/investment-declaration/investment-declaration-form",
        "/investment-declaration/tax-calculation",
        "/statutory-details"
      ],
      details: [
        { url: "/salary-configuration", name: "Salary Configuration", icon: "fa-regular fa-hand-holding-usd" },
        { url: "/statutory-details", name: "Statutory Details", icon: "fa-regular fa-address-card" },
        { url: "/payslip", name: "Payslip", icon: "fa-regular fa-address-card" },
        // { url: "/investment-declaration", name: "Tax Calculation", icon: "fa-regular fa-address-card" },

      ],
    },
    {
      id: [
        "/profile-details",
        "/attendance-details",
        "/leave-details",
        "/my-documents",
        "/my-performance",
        "/asset-details",
        "/kra-list",
        "/leaves/apply-leave",
        "/compoff/apply-compoff",
        "/performance",
        "/access-control",
        "/monthly-attendance",
        "/cv-details",
        "/calender",
        "/my-timesheet",
        "/pip-user-list/feedback"
      ],
      details: [
        { url: "/profile-details", name: "Profile", icon: "fa-regular fa-user" },
        { url: "/attendance-details", name: "Attendance", icon: "fa-regular fa-address-card" },
        { url: "/leave-details", name: "Leave", icon: "fa-regular fa-address-card" },
        { url: "/my-documents", name: "My Document", icon: "fa-regular fa-file" },
        { url: "/performance", name: "Performance", icon: "fa-regular fa-address-card" },
        { url: "/access-control", name: "Access Control", icon: "fa-regular fa-address-card" },
        { url: "/kra-list", name: "KRA", icon: "fa-regular fa-address-card" },
        { url: "/my-timesheet", name: "Timesheet", icon: "fa-regular fa-address-card" },
      ],
    },
    {
      id: ["/my-team-leave", "/my-team-attendance", "/my-team-timesheet", "/my-team-timesheet/timesheet-details", "/my-team-tasks", "/my-team-tasks/subtask",
        "/my-team-tasks/issue-details"
      ],
      details: [
        { url: "/my-team-leave", name: "Leave", icon: "fa-regular fa fa-group" },
        { url: "/my-team-attendance", name: "Attendance", icon: "fa-regular fa-address-card" },
        { url: "/my-team-timesheet", name: "Timesheet", icon: "fa-regular fa-address-card" },
        { url: "/my-team-tasks", name: "Task Assigned", icon: "fa-regular fa-address-card" },
      ],
    },
    {
      id: ["/policies"],
      details: [{ url: "/policies", name: "Policies", icon: "fa-regular fa-file" }],
    },
    {
      id: ["/holidays"],
      details: [{ url: "/holidays", name: "Holiday", icon: "fa-regular fa-calendar" }],
    },
    {
      id: ["/organization-chart"],
      details: [{ url: "/organization-chart", name: "Organization Chart", icon: "fa-regular fa fa-sitemap" }],
    },

    {
      id: [
        "/asset-list",
        "/asset-list/asset-details",
        "/assigned-asset",
        "/assigned-asset/asset-detail",
      ],
      details: [
        { url: "/asset-list", name: "Assets", icon: "fa-regular fa fa-laptop" },
        { url: "/assigned-asset", name: "Assets Assignments", icon: "fa-regular fa-address-card" },
      ],
    },
    {
      id: ["/my-tracker-activity", "/tracker-screenshot"],
      details: [{ url: "/my-tracker-activity", name: "My Screen Activities", icon: "fa-regular fa fa-laptop" },
      { url: "/tracker-screenshot", name: "Others Screen Activities", icon: "fa-regular fa fa-laptop" }],
    },
    {
      id: [
        "/jobs",
        "/jobs/job-details",
        "/jobs/job-applicants",
        "/jobs/job-applicants/applicant-details",
        "/jobs/job-applicants/job-interviews",
        "/jobs/job-applicants/job-interviews/interview-details",
        "/jobs/job-applicants/job-interviews/feedback-form",
        "/interview-list-by-user",
        "/interview-list-by-user/feedback-form",
        "/jobs/job-applicants/job-interviews/consolidated-report",
        "/unique-candidates", "/unique-candidates-history"
      ],
      details: [
        { url: "/jobs", name: "Jobs", icon: "fa-regular fa-envelope" },
        { url: "/interview-list-by-user", name: "Interviews", icon: "fa-regular fa fa-group" },
        { url: "/unique-candidates", name: "Candidates", icon: "fa-regular fa fa-group" },
      ],
    },
    {
      id: ["/dashboard-contacts", "/contacts", "/contacts/view-contact", "/deals", "/deals/view-deals",
        "/daily-sales-report", "/sequences", "/sequences/sequence-details", "/sales-documents"],
      details: [
        { url: "/dashboard-contacts", name: "Dashboard", icon: "fa-regular fa-address-card" },
        { url: "/contacts", name: "Contacts", icon: "fa-regular fa-address-card" },
        { url: "/deals", name: "Deals", icon: "fa-regular fa-address-card" },
        { url: "/daily-sales-report", name: "Daily Sales Report", icon: "fa-regular fa-address-card" },
        { url: "/sequences", name: "Sequences", icon: "fa-regular fa-address-card" },
        { url: "/sales-documents", name: "Documents", icon: "fa-regular fa-address-card" },

      ],
    },
    {
      id: ["/rd-drive", "/rd-drive/drive-analytic", "/rd-drive/folders", "/rd-drive/folder-drive-analytic"],
      details: [
        { url: "/rd-drive", name: "Drive", icon: "fa-regular fa-address-card" },
      ],
    },
    {
      id: ["/appraisal-event-list", "/appraisal-event-list/appraisal", "/appraisal-event-list/appraisal/appraisal-review"],
      details: [
        { url: "/appraisal-event-list", name: "Appraisal" },
      ],
    },
    {
      id: ["/my-tickets", "/manage-tickets", "/my-tickets/ticket-details", "/manage-tickets/ticket-details", "/access-control-tickets"],
      details: [
        { url: "/my-tickets", name: "My Tickets", icon: "fa-regular fa fa-ticket" },
        { url: "/manage-tickets", name: "Manage Tickets", icon: "fa-regular fa-address-card" },
        { url: "/access-control-tickets", name: "Access Control", icon: "fa-regular fa-address-card" },
      ],
    },
    {
      id: ["/trainings", "/training-calender", "/trainings/training-details"],
      details: [
        { url: "/trainings", name: "Training Schedules", icon: "fa-regular fa fa-graduation-cap" },
        { url: "/training-calender", name: "Calender", icon: "fa-regular fa-calender" },
      ],
    },
    {
      id: ["/event-list", "/event-list/my-appraisal"], //["/my-appraisal", "/others-appraisal", "/appraisal-employee/appraisal-review"],
      details: [
        // { url: "/my-appraisal", name: "My Appraisal",icon:"fa-regular fa fa-shield" },
        // { url: "/others-appraisal", name: "Others Appraisal",icon:"fa-regular fa-address-card" },
      ],
    },
    {
      id: ["/employee-calender"],
      details: [{ url: "/employee-calender", name: "Dashboard", icon: "fa-regular fa-calender" }],
    },

    {
      id: ["/data-mining"],
      details: [{ url: "/data-mining", name: "Data Mining", icon: "fa-regular fa-database" }],
    },
    {
      id: ["/reimbursement"],
      details: [{ url: "/reimbursement", name: "Reimbursements", icon: "fa-regular fa-undo" }],
    },

    {
      id: ["/projects", "/projects/project-details", "/projects/project-details/subtask", "/projects/issue-details", "/projects-timesheet", "/projects-timesheet/timesheet-details", "/projects/project-details/documents"],
      details: [
        { url: "/projects", name: "Projects", icon: "fa-regular fa-task" },
        { url: "/projects-timesheet", name: "Timesheet", icon: "fa-regular fa-task" },
      ],
    },
    {
      id: ["/project-report"],
      details: [{ url: "/project-report", name: "Resource Utilization Reports", icon: "fa-regular fa-task" },],
    },
    {
      id: ["/help"],
      details: [
        {
          url: "/help", name: "Help",
        }]
    },
    {
      id: ["/change-request", "/change-request/request-details"],
      details: [
        {
          url: "/change-request", name: "Change Request"
        }]
    },
    {
      id: ["/academy/leads", "/academy/source", "/academy/course", "/academy/status"],
      details: [
        {
          url: "/academy/leads", name: "Leads",
        },
        {
          url: "/academy/source", name: "Source",
        },
        {
          url: "/academy/course", name: "Course",
        },
        {
          url: "/academy/status", name: "Status",
        },]
    },
    {
      id: ["/settings"],
      details: [
        {
          url: "/settings", name: "Settings",
        }]
    },
    {
      id: ["/website-candidates"],
      details: [{ url: "/website-candidates", name: "Website Candidates", icon: "fa-regular fa fa-group" }],
    },
    {
      id: ["/cost-fields", "/team-member", "/discount", "/cost-fields/cost-fields-form"],
      details: [
        { url: "/cost-fields", name: "Cost Calculator" },
        { url: "/team-member", name: "Team Member" },
        { url: "/discount", name: "Discount" },
      ],
    },
    //AI Chatboat
    {
      id: [
        "/contact-dashboard", "/contact-forms", "/appointments", "/chat-forms", "/chat-attachments"

      ],
      details: [
        { url: "/contact-dashboard", name: "Dashboard", icon: "fa-regular fa fa-bar-chart" },
        { url: "/contact-forms", name: "Visitors", icon: "fa-regular fa fa-group" },
        { url: "/appointments", name: "Appointments", icon: "fa-regular fa-calendar" },
        { url: "/chat-forms", name: "Forms", icon: "fa-regular fa fa-check-square" },
        { url: "/chat-attachments", name: "Attachments", icon: "fa-regular fa fa-file" }

      ],
    },
    //Human Chatboat
    {
      id: [
        "/chat-with-visitors", "/visitor-chat-history-list"
      ],
      details: [
        { url: "/chat-with-visitors", name: "Live Chat", icon: "fa-regular fa fa-wechat" },
        { url: "/visitor-chat-history-list", name: "Chat Archive", icon: "fa-regular fa fa-history" }


      ],
    },
    {
      id: ["/my-reviews", "/others-reviews", "others-reviews/add"],
      details: [
        { url: "/my-reviews", name: "My Reviews" },
        { url: "/others-reviews", name: "Others Reviews" }
      ],
    },
    {
      id: ["/pending-leave-approvals", "/all-approval-leaves"],
      details: [
        { url: "/pending-leave-approvals", name: "Pending Leaves" },
        { url: "/all-approval-leaves", name: "All Leaves" }
      ],
    },
    {
      id: ["/message-board"],
      details: [
        {
          url: "/message-board", name: "Message Board",
        }]
    },

    {
      id: ["/confirmation-event-list", "/confirmation-event-list/confirmation", "/confirmation-event-list/confirmation/confirmation-review"],
      details: [
        { url: "/confirmation-event-list", name: "Confirmation" },
      ],
    },

    {
      id: ["/meeting-room-booking-list"],
      details: [
        { url: "/meeting-room-booking-list", name: "MRoom Booking", icon: "fa-regular fa fa-calender" },
      ],
    },
  ],
  languageSpoken: [
    { id: "english", name: "English" },
    { id: "hindi", name: "Hindi" },
    { id: "bengali", name: "Bengali" },
  ],

  visitorPurpose: [
    { id: "official", name: "Official" },
    { id: "interview", name: "Interview" },
    { id: "audit", name: "Audit" },
    { id: "banking", name: "Banking" },
    { id: "other", name: "Other" }
  ],
  bankPaymentMode: [
    { id: 'cash', name: "Cash" },
    { id: 'bank_transfer', name: "Bank Transfer" },
  ],
  jobVisibility: [
    { id: 'internal', name: 'Internal' },
    { id: 'website', name: 'Website' },
    { id: 'all', name: 'All' },
  ],

  dataMiningPurpose: [
    { id: 'game', name: 'Game' },
    { id: 'web', name: 'Web' },
    { id: 'app', name: 'App' },
    { id: 'general', name: 'General' },
  ],
  reimbursementStatuses: [
    { id: 'pending', name: 'Pending' },
    { id: 'approved', name: 'Approved' },
    { id: 'rejected', name: 'Rejected' },
  ],
  dataMiningIndustry: [
    { id: 'Aerospace & Defense', name: 'Aerospace & Defense' },
    { id: 'Automotive', name: 'Automotive' },
    { id: 'Banking, Finance, Insurance', name: 'Banking, Finance, Insurance' },
    { id: 'Communication, Media & Entertainment', name: 'Communication, Media & Entertainment' },
    { id: 'Chemicals', name: 'Chemicals' },
    { id: 'Consumer Goods', name: 'Consumer Goods' },
    { id: 'Construction', name: 'Construction' },
    { id: 'Casino', name: 'Casino' },
    { id: 'Education', name: 'Education' },
    { id: 'Entertainment', name: 'Entertainment' },
    { id: 'Electronics', name: 'Electronics' },
    { id: 'Energy & Utilities', name: 'Energy & Utilities' },
    { id: 'Government', name: 'Government' },
    { id: 'Game', name: 'Game' },
    { id: 'High Tech', name: 'High Tech' },
    { id: 'Information Services', name: 'Information Services' },
    { id: 'Life Science', name: 'Life Science' },
    { id: 'Manufacturing', name: 'Manufacturing' },
    { id: 'Mining', name: 'Mining' },
    { id: 'Natural Resource', name: 'Natural Resource' },
    { id: 'Oil & Gas', name: 'Oil & Gas' },
    { id: 'Public Services', name: 'Public Services' },
    { id: 'Restaurants', name: 'Restaurants' },
    { id: 'Retail', name: 'Retail' },
    { id: 'Travel, Tourism & Transport', name: 'Travel, Tourism & Transport' },
    { id: 'Telecommunications', name: 'Telecommunications' },
    { id: 'Utilities', name: 'Utilities' },
  ],

  dataMiningNoOfEmp: [
    { id: '1-10', name: '1-10' },
    { id: '11-50', name: '11-50' },
    { id: '51-200', name: '51-200' },
    { id: '201-500', name: '201-500' },
    { id: '501-Above', name: '501-Above' },
  ],
  trainingAttendanceStatus: [
    { id: 'present', name: "Present" },
    { id: 'absent', name: "Absent" },
    { id: 'none', name: "None" },
  ],
  trainingParticipantAttendance: [
    { id: 'invited', name: "Invited" },
    { id: 'present', name: "Present" },
    { id: 'absent', name: "Absent" },
    { id: 'busy', name: "Busy with other work" },
  ],

  projectDropdownTypes: [
    { id: 'recent_projects', name: "Recent Projects" },
    { id: 'view_all_projects', name: "View All Projects" },
    { id: 'create_project', name: "Create Project" },
  ],

  projectTaskType: [
    { id: 'user_story', name: "User Story" },
    { id: 'task', name: "Task" },
  ],
  rate: [
    { id: -1, name: "NA" },
    { id: 0, name: "0" },
    { id: 1, name: "1" },
    { id: 1.5, name: "1.5" },
    { id: 2, name: "2" },
    { id: 2.5, name: "2.5" },
    { id: 3, name: "3" },
    { id: 3.5, name: "3.5" },
    { id: 4, name: "4" },
    { id: 4.5, name: "4.5" },
    { id: 5, name: "5" },
    { id: 5.5, name: "5.5" },
    { id: 6, name: "6" },
    { id: 6.6, name: "6.5" },
    { id: 7, name: "7" },
    { id: 7.5, name: "7.5" },
    { id: 8, name: "8" },
    { id: 8.5, name: "8.5" },
    { id: 9, name: "9" },
    { id: 9.5, name: "9.5" },
    { id: 10, name: "10" },

  ],
  contactType: [
    { id: 1, name: "Upload CSV" },
    { id: 2, name: "Select from list" }
  ],

  sequenceStatus: [
    { id: "start_now", name: "Start Now" },
    { id: "schedule", name: "Schedule" }
  ],

  timeBetweenStep: [
    { id: "minutes", name: "minutes" },
    { id: "hours", name: "hours" },
    { id: "days", name: "days" }
  ],

  sequenceStepConditions: [
    { value: 1, label: "Who hasn't opened the email in previous step" },
    { value: 2, label: "Who has opened the email in previous step but not responded" },
    { value: 3, label: "Who has replied to the email in previous step" }
  ],

  existingContactUpdate: [
    { id: 1, name: "Update the existing record with information from CSV" },
    { id: 0, name: "Skip it (Do not update existing record)" }
  ],
  timeSheetDurations: [
    { id: "total_hours", name: "Total Hours" },
    { id: "start_end_time", name: "Start & End Time" }
  ],
  projectIsBillableList: [
    { id: 1, name: "Billable" },
    { id: 0, name: "Non-billable" },

  ],
  getVisibility: [
    { id: 'public', name: "Public" },
    { id: 'private', name: "Private" },
    { id: 'shared', name: "Shared" }
  ],
  getEffortType: [
    { id: 'internal', name: "Internal" },
    { id: 'change_request', name: "Change Request" },
  ],

  hourArray: [
    { id: 0, name: "0" },
    { id: 1, name: "1" },
    { id: 2, name: "2" },
    { id: 3, name: "3" },
    { id: 4, name: "4" },
    { id: 5, name: "5" },
    { id: 6, name: "6" },
    { id: 7, name: "7" },
    { id: 8, name: "8" },
    { id: 9, name: "9" },
    { id: 10, name: "10" },
    { id: 11, name: "11" },
    { id: 12, name: "12" },
    { id: 13, name: "13" },
    { id: 14, name: "14" },
    { id: 15, name: "15" },
    { id: 16, name: "16" },
    { id: 17, name: "17" },
    { id: 18, name: "18" },
    { id: 19, name: "19" },
    { id: 20, name: "20" },
    { id: 21, name: "21" },
    { id: 22, name: "22" },
    { id: 23, name: "23" },
    { id: 24, name: "24" },
  ],

  minArray: [
    { id: 0, name: "0" },
    { id: 5, name: "5" },
    { id: 10, name: "10" },
    { id: 15, name: "15" },
    { id: 20, name: "20" },
    { id: 25, name: "25" },
    { id: 30, name: "30" },
    { id: 35, name: "35" },
    { id: 40, name: "40" },
    { id: 45, name: "45" },
    { id: 50, name: "50" },
    { id: 55, name: "55" },
    { id: 60, name: "60" },
  ],
  getFilter: [
    { id: 'all', name: "All" },
    { id: 'current', name: "Current" },
    { id: 'previous', name: "Previous" },
  ],

  getExceptionRequestTypes: [
    { id: 'time_change_request', name: "Time Change Request" },
    { id: 'work_from_home', name: "Work From Home" },
    { id: 'outdoor_activity', name: "Outdoor Activity" },
  ],

  getTimeSheetStatus: [
    { id: 'waiting_for_approval', name: "Waiting For Approval" },
    { id: 'approved', name: "Approved" },
    { id: 'rejected', name: "Rejected" },
  ],

  arrUtilizationFilter: [
    { id: "day", name: "Day" },
    { id: "month", name: "Month" },
    { id: "year", name: "Year" },
  ],

  taskMasterStatuses: [
    { id: "open", name: "Open" },
    { id: "closed", name: "Closed" },
    { id: "not_started", name: "Not Started" },
  ],
  getReviewActiveFilter: [
    { id: "pending", name: "Pending Only" },
    { id: "approved", name: "Approved Only" },
    { id: "rejected", name: "Rejected" },
    { id: "", name: "All Requests" },
  ],

  costCalculatorRequiredService: [
    { id: 1, name: "Hire Your Own Team", is_checked: 0 },
    { id: 2, name: "Get A Fixed Cost", is_checked: 0 },
    { id: 3, name: "Update on Existing Development", is_checked: 0 },
  ],
  timeZone: [{ "zone": "Pacific/Midway", "gmt": "(GMT-11:00)", "name": "Midway Island" }, { "zone": "US/Samoa", "gmt": "(GMT-11:00)", "name": "Samoa" }, { "zone": "US/Hawaii", "gmt": "(GMT-10:00)", "name": "Hawaii" }, { "zone": "US/Alaska", "gmt": "(GMT-09:00)", "name": "Alaska" }, { "zone": "US/Pacific", "gmt": "(GMT-08:00)", "name": "Pacific Time (US & Canada)" }, { "zone": "America/Tijuana", "gmt": "(GMT-08:00)", "name": "Tijuana" }, { "zone": "US/Arizona", "gmt": "(GMT-07:00)", "name": "Arizona" }, { "zone": "US/Mountain", "gmt": "(GMT-07:00)", "name": "Mountain Time (US & Canada)" }, { "zone": "America/Chihuahua", "gmt": "(GMT-07:00)", "name": "Chihuahua" }, { "zone": "America/Mazatlan", "gmt": "(GMT-07:00)", "name": "Mazatlan" }, { "zone": "America/Mexico_City", "gmt": "(GMT-06:00)", "name": "Mexico City" }, { "zone": "America/Monterrey", "gmt": "(GMT-06:00)", "name": "Monterrey" }, { "zone": "Canada/Saskatchewan", "gmt": "(GMT-06:00)", "name": "Saskatchewan" }, { "zone": "US/Central", "gmt": "(GMT-06:00)", "name": "Central Time (US & Canada)" }, { "zone": "US/Eastern", "gmt": "(GMT-05:00)", "name": "Eastern Time (US & Canada)" }, { "zone": "US/East-Indiana", "gmt": "(GMT-05:00)", "name": "Indiana (East)" }, { "zone": "America/Bogota", "gmt": "(GMT-05:00)", "name": "Bogota" }, { "zone": "America/Lima", "gmt": "(GMT-05:00)", "name": "Lima" }, { "zone": "America/Caracas", "gmt": "(GMT-04:30)", "name": "Caracas" }, { "zone": "Canada/Atlantic", "gmt": "(GMT-04:00)", "name": "Atlantic Time (Canada)" }, { "zone": "America/La_Paz", "gmt": "(GMT-04:00)", "name": "La_Paz" }, { "zone": "America/Santiago", "gmt": "(GMT-04:00)", "name": "Santiago" }, { "zone": "Canada/Newfoundland", "gmt": "(GMT-03:30)", "name": "Newfoundland" }, { "zone": "America/Buenos_Aires", "gmt": "(GMT-03:00)", "name": "Buenos Aires" }, { "zone": "Greenland", "gmt": "(GMT-03:00)", "name": "Greenland" }, { "zone": "Atlantic/Stanley", "gmt": "(GMT-02:00)", "name": "Stanley" }, { "zone": "Atlantic/Azores", "gmt": "(GMT-01:00)", "name": "Azores" }, { "zone": "Atlantic/Cape_Verde", "gmt": "(GMT-01:00)", "name": "Cape Verde Is." }, { "zone": "Africa/Casablanca", "gmt": "(GMT)", "name": "Casablanca" }, { "zone": "Europe/Dublin", "gmt": "(GMT)", "name": "Dublin" }, { "zone": "Europe/Lisbon", "gmt": "(GMT)", "name": "Libson" }, { "zone": "Europe/London", "gmt": "(GMT)", "name": "London" }, { "zone": "Africa/Monrovia", "gmt": "(GMT)", "name": "Monrovia" }, { "zone": "Europe/Amsterdam", "gmt": "(GMT+01:00)", "name": "Amsterdam" }, { "zone": "Europe/Belgrade", "gmt": "(GMT+01:00)", "name": "Belgrade" }, { "zone": "Europe/Berlin", "gmt": "(GMT+01:00)", "name": "Berlin" }, { "zone": "Europe/Bratislava", "gmt": "(GMT+01:00)", "name": "Bratislava" }, { "zone": "Europe/Brussels", "gmt": "(GMT+01:00)", "name": "Brussels" }, { "zone": "Europe/Budapest", "gmt": "(GMT+01:00)", "name": "Budapest" }, { "zone": "Europe/Copenhagen", "gmt": "(GMT+01:00)", "name": "Copenhagen" }, { "zone": "Europe/Ljubljana", "gmt": "(GMT+01:00)", "name": "Ljubljana" }, { "zone": "Europe/Madrid", "gmt": "(GMT+01:00)", "name": "Madrid" }, { "zone": "Europe/Paris", "gmt": "(GMT+01:00)", "name": "Paris" }, { "zone": "Europe/Prague", "gmt": "(GMT+01:00)", "name": "Prague" }, { "zone": "Europe/Rome", "gmt": "(GMT+01:00)", "name": "Rome" }, { "zone": "Europe/Sarajevo", "gmt": "(GMT+01:00)", "name": "Sarajevo" }, { "zone": "Europe/Skopje", "gmt": "(GMT+01:00)", "name": "Skopje" }, { "zone": "Europe/Stockholm", "gmt": "(GMT+01:00)", "name": "Stockholm" }, { "zone": "Europe/Vienna", "gmt": "(GMT+01:00)", "name": "Vienna" }, { "zone": "Europe/Warsaw", "gmt": "(GMT+01:00)", "name": "Warsaw" }, { "zone": "Europe/Zagreb", "gmt": "(GMT+01:00)", "name": "Zagreb" }, { "zone": "Europe/Athens", "gmt": "(GMT+02:00)", "name": "Athens" }, { "zone": "Europe/Bucharest", "gmt": "(GMT+02:00)", "name": "Bucharest" }, { "zone": "Africa/Cairo", "gmt": "(GMT+02:00)", "name": "Cairo" }, { "zone": "Africa/Harare", "gmt": "(GMT+02:00)", "name": "Harere" }, { "zone": "Europe/Helsinki", "gmt": "(GMT+02:00)", "name": "Helsinki" }, { "zone": "Europe/Istanbul", "gmt": "(GMT+02:00)", "name": "Istanbul" }, { "zone": "Asia/Jerusalem", "gmt": "(GMT+02:00)", "name": "Jerusalem" }, { "zone": "Europe/Kiev", "gmt": "(GMT+02:00)", "name": "Kiev" }, { "zone": "Europe/Minsk", "gmt": "(GMT+02:00)", "name": "Minsk" }, { "zone": "Europe/Riga", "gmt": "(GMT+02:00)", "name": "Riga" }, { "zone": "Europe/Sofia", "gmt": "(GMT+02:00)", "name": "Sofia" }, { "zone": "Europe/Tallinn", "gmt": "(GMT+02:00)", "name": "Tallinn" }, { "zone": "Europe/Vilnius", "gmt": "(GMT+02:00)", "name": "Vilnius" }, { "zone": "Asia/Baghdad", "gmt": "(GMT+03:00)", "name": "Baghdad" }, { "zone": "Asia/Kuwait", "gmt": "(GMT+03:00)", "name": "Kuwait" }, { "zone": "Africa/Nairobi", "gmt": "(GMT+03:00)", "name": "Nairobi" }, { "zone": "Asia/Riyadh", "gmt": "(GMT+03:00)", "name": "Riyadh" }, { "zone": "Asia/Tehran", "gmt": "(GMT+03:30)", "name": "Tehran" }, { "zone": "Europe/Moscow", "gmt": "(GMT+04:00)", "name": "Moscow" }, { "zone": "Asia/Baku", "gmt": "(GMT+04:00)", "name": "Baku" }, { "zone": "Europe/Volgograd", "gmt": "(GMT+04:00)", "name": "Volgograd" }, { "zone": "Asia/Muscat", "gmt": "(GMT+04:00)", "name": "Muscat" }, { "zone": "Asia/Tbilisi", "gmt": "(GMT+04:00)", "name": "Tbilisi" }, { "zone": "Asia/Yerevan", "gmt": "(GMT+04:00)", "name": "Yerevan" }, { "zone": "Asia/Kabul", "gmt": "(GMT+04:30)", "name": "Kabul" }, { "zone": "Asia/Karachi", "gmt": "(GMT+05:00)", "name": "Karachi" }, { "zone": "Asia/Tashkent", "gmt": "(GMT+05:00)", "name": "Tashkent" }, { "zone": "Asia/Calcutta", "gmt": "(GMT+05:30)", "name": "Indian Standard Time" }, { "zone": "Asia/Kathmandu", "gmt": "(GMT+05:45)", "name": "Kathmandu" }, { "zone": "Asia/Yekaterinburg", "gmt": "(GMT+06:00)", "name": "Yekaterinburg" }, { "zone": "Asia/Almaty", "gmt": "(GMT+06:00)", "name": "Almaty" }, { "zone": "Asia/Dhaka", "gmt": "(GMT+06:00)", "name": "Dhaka" }, { "zone": "Asia/Novosibirsk", "gmt": "(GMT+07:00)", "name": "Novosibirsk" }, { "zone": "Asia/Bangkok", "gmt": "(GMT+07:00)", "name": "Bangkok" }, { "zone": "Asia/Jakarta", "gmt": "(GMT+07:00)", "name": "Jakarta" }, { "zone": "Asia/Krasnoyarsk", "gmt": "(GMT+08:00)", "name": "Krasnoyarsk" }, { "zone": "Asia/Chongqing", "gmt": "(GMT+08:00)", "name": "Chongqing" }, { "zone": "Asia/Hong_Kong", "gmt": "(GMT+08:00)", "name": "Hong Kong" }, { "zone": "Asia/Kuala_Lumpur", "gmt": "(GMT+08:00)", "name": "Kuala Lumpur" }, { "zone": "Australia/Perth", "gmt": "(GMT+08:00)", "name": "Perth" }, { "zone": "Asia/Singapore", "gmt": "(GMT+08:00)", "name": "Singapore" }, { "zone": "Asia/Taipei", "gmt": "(GMT+08:00)", "name": "Taipei" }, { "zone": "Asia/Ulaanbaatar", "gmt": "(GMT+08:00)", "name": "Ulaan Bataar" }, { "zone": "Asia/Urumqi", "gmt": "(GMT+08:00)", "name": "Urumqi" }, { "zone": "Asia/Irkutsk", "gmt": "(GMT+09:00)", "name": "Irkutsk" }, { "zone": "Asia/Seoul", "gmt": "(GMT+09:00)", "name": "Seoul" }, { "zone": "Asia/Tokyo", "gmt": "(GMT+09:00)", "name": "Tokyo" }, { "zone": "Australia/Adelaide", "gmt": "(GMT+09:30)", "name": "Adelaide" }, { "zone": "Australia/Darwin", "gmt": "(GMT+09:30)", "name": "Darwin" }, { "zone": "Asia/Yakutsk", "gmt": "(GMT+10:00)", "name": "Yakutsk" }, { "zone": "Australia/Brisbane", "gmt": "(GMT+10:00)", "name": "Brisbane" }, { "zone": "Australia/Canberra", "gmt": "(GMT+10:00)", "name": "Canberra" }, { "zone": "Pacific/Guam", "gmt": "(GMT+10:00)", "name": "Guam" }, { "zone": "Australia/Hobart", "gmt": "(GMT+10:00)", "name": "Hobart" }, { "zone": "Australia/Melbourne", "gmt": "(GMT+10:00)", "name": "Melbourne" }, { "zone": "Pacific/Port_Moresby", "gmt": "(GMT+10:00)", "name": "Port Moresby" }, { "zone": "Australia/Sydney", "gmt": "(GMT+10:00)", "name": "Sydney" }, { "zone": "Asia/Vladivostok", "gmt": "(GMT+11:00)", "name": "Vladivostok" }, { "zone": "Asia/Magadan", "gmt": "(GMT+12:00)", "name": "Magadan" }, { "zone": "Pacific/Auckland", "gmt": "(GMT+12:00)", "name": "Auckland" }, { "zone": "Pacific/Fiji", "gmt": "(GMT+12:00)", "name": "Fiji" }],

  countryCodewithflag: [
    {
      "name": "Afghanistan",
      "flag": "🇦🇫",
      "code": "AF",
      "dial_code": " 93"
    },
    {
      "name": "Åland Islands",
      "flag": "🇦🇽",
      "code": "AX",
      "dial_code": " 358"
    },
    {
      "name": "Albania",
      "flag": "🇦🇱",
      "code": "AL",
      "dial_code": " 355"
    },
    {
      "name": "Algeria",
      "flag": "🇩🇿",
      "code": "DZ",
      "dial_code": " 213"
    },
    {
      "name": "American Samoa",
      "flag": "🇦🇸",
      "code": "AS",
      "dial_code": " 1684"
    },
    {
      "name": "Andorra",
      "flag": "🇦🇩",
      "code": "AD",
      "dial_code": " 376"
    },
    {
      "name": "Angola",
      "flag": "🇦🇴",
      "code": "AO",
      "dial_code": " 244"
    },
    {
      "name": "Anguilla",
      "flag": "🇦🇮",
      "code": "AI",
      "dial_code": " 1264"
    },
    {
      "name": "Antarctica",
      "flag": "🇦🇶",
      "code": "AQ",
      "dial_code": " 672"
    },
    {
      "name": "Antigua and Barbuda",
      "flag": "🇦🇬",
      "code": "AG",
      "dial_code": " 1268"
    },
    {
      "name": "Argentina",
      "flag": "🇦🇷",
      "code": "AR",
      "dial_code": " 54"
    },
    {
      "name": "Armenia",
      "flag": "🇦🇲",
      "code": "AM",
      "dial_code": " 374"
    },
    {
      "name": "Aruba",
      "flag": "🇦🇼",
      "code": "AW",
      "dial_code": " 297"
    },
    {
      "name": "Australia",
      "flag": "🇦🇺",
      "code": "AU",
      "dial_code": " 61"
    },
    {
      "name": "Austria",
      "flag": "🇦🇹",
      "code": "AT",
      "dial_code": " 43"
    },
    {
      "name": "Azerbaijan",
      "flag": "🇦🇿",
      "code": "AZ",
      "dial_code": " 994"
    },
    {
      "name": "Bahamas",
      "flag": "🇧🇸",
      "code": "BS",
      "dial_code": " 1242"
    },
    {
      "name": "Bahrain",
      "flag": "🇧🇭",
      "code": "BH",
      "dial_code": " 973"
    },
    {
      "name": "Bangladesh",
      "flag": "🇧🇩",
      "code": "BD",
      "dial_code": " 880"
    },
    {
      "name": "Barbados",
      "flag": "🇧🇧",
      "code": "BB",
      "dial_code": " 1246"
    },
    {
      "name": "Belarus",
      "flag": "🇧🇾",
      "code": "BY",
      "dial_code": " 375"
    },
    {
      "name": "Belgium",
      "flag": "🇧🇪",
      "code": "BE",
      "dial_code": " 32"
    },
    {
      "name": "Belize",
      "flag": "🇧🇿",
      "code": "BZ",
      "dial_code": " 501"
    },
    {
      "name": "Benin",
      "flag": "🇧🇯",
      "code": "BJ",
      "dial_code": " 229"
    },
    {
      "name": "Bermuda",
      "flag": "🇧🇲",
      "code": "BM",
      "dial_code": " 1441"
    },
    {
      "name": "Bhutan",
      "flag": "🇧🇹",
      "code": "BT",
      "dial_code": " 975"
    },
    {
      "name": "Bolivia",
      "flag": "🇧🇴",
      "code": "BO",
      "dial_code": " 591"
    },
    {
      "name": "Bosnia and Herzegovina",
      "flag": "🇧🇦",
      "code": "BA",
      "dial_code": " 387"
    },
    {
      "name": "Botswana",
      "flag": "🇧🇼",
      "code": "BW",
      "dial_code": " 267"
    },
    {
      "name": "Bouvet Island",
      "flag": "🇧🇻",
      "code": "BV",
      "dial_code": " 47"
    },
    {
      "name": "Brazil",
      "flag": "🇧🇷",
      "code": "BR",
      "dial_code": " 55"
    },
    {
      "name": "British Indian Ocean Territory",
      "flag": "🇮🇴",
      "code": "IO",
      "dial_code": " 246"
    },
    {
      "name": "Brunei Darussalam",
      "flag": "🇧🇳",
      "code": "BN",
      "dial_code": " 673"
    },
    {
      "name": "Bulgaria",
      "flag": "🇧🇬",
      "code": "BG",
      "dial_code": " 359"
    },
    {
      "name": "Burkina Faso",
      "flag": "🇧🇫",
      "code": "BF",
      "dial_code": " 226"
    },
    {
      "name": "Burundi",
      "flag": "🇧🇮",
      "code": "BI",
      "dial_code": " 257"
    },
    {
      "name": "Cambodia",
      "flag": "🇰🇭",
      "code": "KH",
      "dial_code": " 855"
    },
    {
      "name": "Cameroon",
      "flag": "🇨🇲",
      "code": "CM",
      "dial_code": " 237"
    },
    {
      "name": "Canada",
      "flag": "🇨🇦",
      "code": "CA",
      "dial_code": " 1"
    },
    {
      "name": "Cape Verde",
      "flag": "🇨🇻",
      "code": "CV",
      "dial_code": " 238"
    },
    {
      "name": "Cayman Islands",
      "flag": "🇰🇾",
      "code": "KY",
      "dial_code": " 345"
    },
    {
      "name": "Central African Republic",
      "flag": "🇨🇫",
      "code": "CF",
      "dial_code": " 236"
    },
    {
      "name": "Chad",
      "flag": "🇹🇩",
      "code": "TD",
      "dial_code": " 235"
    },
    {
      "name": "Chile",
      "flag": "🇨🇱",
      "code": "CL",
      "dial_code": " 56"
    },
    {
      "name": "China",
      "flag": "🇨🇳",
      "code": "CN",
      "dial_code": " 86"
    },
    {
      "name": "Christmas Island",
      "flag": "🇨🇽",
      "code": "CX",
      "dial_code": " 61"
    },
    {
      "name": "Cocos (Keeling) Islands",
      "flag": "🇨🇨",
      "code": "CC",
      "dial_code": " 61"
    },
    {
      "name": "Colombia",
      "flag": "🇨🇴",
      "code": "CO",
      "dial_code": " 57"
    },
    {
      "name": "Comoros",
      "flag": "🇰🇲",
      "code": "KM",
      "dial_code": " 269"
    },
    {
      "name": "Congo",
      "flag": "🇨🇬",
      "code": "CG",
      "dial_code": " 242"
    },
    {
      "name": "Congo, The Democratic Republic of the Congo",
      "flag": "🇨🇩",
      "code": "CD",
      "dial_code": " 243"
    },
    {
      "name": "Cook Islands",
      "flag": "🇨🇰",
      "code": "CK",
      "dial_code": " 682"
    },
    {
      "name": "Costa Rica",
      "flag": "🇨🇷",
      "code": "CR",
      "dial_code": " 506"
    },
    {
      "name": "Côte d'Ivoire",
      "flag": "🇨🇮",
      "code": "CI",
      "dial_code": " 225"
    },
    {
      "name": "Croatia",
      "flag": "🇭🇷",
      "code": "HR",
      "dial_code": " 385"
    },
    {
      "name": "Cuba",
      "flag": "🇨🇺",
      "code": "CU",
      "dial_code": " 53"
    },
    {
      "name": "Cyprus",
      "flag": "🇨🇾",
      "code": "CY",
      "dial_code": " 357"
    },
    {
      "name": "Czech Republic",
      "flag": "🇨🇿",
      "code": "CZ",
      "dial_code": " 420"
    },
    {
      "name": "Denmark",
      "flag": "🇩🇰",
      "code": "DK",
      "dial_code": " 45"
    },
    {
      "name": "Djibouti",
      "flag": "🇩🇯",
      "code": "DJ",
      "dial_code": " 253"
    },
    {
      "name": "Dominica",
      "flag": "🇩🇲",
      "code": "DM",
      "dial_code": " 1767"
    },
    {
      "name": "Dominican Republic",
      "flag": "🇩🇴",
      "code": "DO",
      "dial_code": " 1849"
    },
    {
      "name": "Ecuador",
      "flag": "🇪🇨",
      "code": "EC",
      "dial_code": " 593"
    },
    {
      "name": "Egypt",
      "flag": "🇪🇬",
      "code": "EG",
      "dial_code": " 20"
    },
    {
      "name": "El Salvador",
      "flag": "🇸🇻",
      "code": "SV",
      "dial_code": " 503"
    },
    {
      "name": "Equatorial Guinea",
      "flag": "🇬🇶",
      "code": "GQ",
      "dial_code": " 240"
    },
    {
      "name": "Eritrea",
      "flag": "🇪🇷",
      "code": "ER",
      "dial_code": " 291"
    },
    {
      "name": "Estonia",
      "flag": "🇪🇪",
      "code": "EE",
      "dial_code": " 372"
    },
    {
      "name": "Ethiopia",
      "flag": "🇪🇹",
      "code": "ET",
      "dial_code": " 251"
    },
    {
      "name": "Falkland Islands (Malvinas)",
      "flag": "🇫🇰",
      "code": "FK",
      "dial_code": " 500"
    },
    {
      "name": "Faroe Islands",
      "flag": "🇫🇴",
      "code": "FO",
      "dial_code": " 298"
    },
    {
      "name": "Fiji",
      "flag": "🇫🇯",
      "code": "FJ",
      "dial_code": " 679"
    },
    {
      "name": "Finland",
      "flag": "🇫🇮",
      "code": "FI",
      "dial_code": " 358"
    },
    {
      "name": "France",
      "flag": "🇫🇷",
      "code": "FR",
      "dial_code": " 33"
    },
    {
      "name": "French Guiana",
      "flag": "🇬🇫",
      "code": "GF",
      "dial_code": " 594"
    },
    {
      "name": "French Polynesia",
      "flag": "🇵🇫",
      "code": "PF",
      "dial_code": " 689"
    },
    {
      "name": "French Southern Territories",
      "flag": "🇹🇫",
      "code": "TF",
      "dial_code": " 262"
    },
    {
      "name": "Gabon",
      "flag": "🇬🇦",
      "code": "GA",
      "dial_code": " 241"
    },
    {
      "name": "Gambia",
      "flag": "🇬🇲",
      "code": "GM",
      "dial_code": " 220"
    },
    {
      "name": "Georgia",
      "flag": "🇬🇪",
      "code": "GE",
      "dial_code": " 995"
    },
    {
      "name": "Germany",
      "flag": "🇩🇪",
      "code": "DE",
      "dial_code": " 49"
    },
    {
      "name": "Ghana",
      "flag": "🇬🇭",
      "code": "GH",
      "dial_code": " 233"
    },
    {
      "name": "Gibraltar",
      "flag": "🇬🇮",
      "code": "GI",
      "dial_code": " 350"
    },
    {
      "name": "Greece",
      "flag": "🇬🇷",
      "code": "GR",
      "dial_code": " 30"
    },
    {
      "name": "Greenland",
      "flag": "🇬🇱",
      "code": "GL",
      "dial_code": " 299"
    },
    {
      "name": "Grenada",
      "flag": "🇬🇩",
      "code": "GD",
      "dial_code": " 1473"
    },
    {
      "name": "Guadeloupe",
      "flag": "🇬🇵",
      "code": "GP",
      "dial_code": " 590"
    },
    {
      "name": "Guam",
      "flag": "🇬🇺",
      "code": "GU",
      "dial_code": " 1671"
    },
    {
      "name": "Guatemala",
      "flag": "🇬🇹",
      "code": "GT",
      "dial_code": " 502"
    },
    {
      "name": "Guernsey",
      "flag": "🇬🇬",
      "code": "GG",
      "dial_code": " 44"
    },
    {
      "name": "Guinea",
      "flag": "🇬🇳",
      "code": "GN",
      "dial_code": " 224"
    },
    {
      "name": "Guinea-Bissau",
      "flag": "🇬🇼",
      "code": "GW",
      "dial_code": " 245"
    },
    {
      "name": "Guyana",
      "flag": "🇬🇾",
      "code": "GY",
      "dial_code": " 592"
    },
    {
      "name": "Haiti",
      "flag": "🇭🇹",
      "code": "HT",
      "dial_code": " 509"
    },
    {
      "name": "Heard Island and Mcdonald Islands",
      "flag": "🇭🇲",
      "code": "HM",
      "dial_code": " 672"
    },
    {
      "name": "Holy See (Vatican City State)",
      "flag": "🇻🇦",
      "code": "VA",
      "dial_code": " 379"
    },
    {
      "name": "Honduras",
      "flag": "🇭🇳",
      "code": "HN",
      "dial_code": " 504"
    },
    {
      "name": "Hong Kong",
      "flag": "🇭🇰",
      "code": "HK",
      "dial_code": " 852"
    },
    {
      "name": "Hungary",
      "flag": "🇭🇺",
      "code": "HU",
      "dial_code": " 36"
    },
    {
      "name": "Iceland",
      "flag": "🇮🇸",
      "code": "IS",
      "dial_code": " 354"
    },
    {
      "name": "India",
      "flag": "🇮🇳",
      "code": "IN",
      "dial_code": " 91"
    },
    {
      "name": "Indonesia",
      "flag": "🇮🇩",
      "code": "ID",
      "dial_code": " 62"
    },
    {
      "name": "Iran",
      "flag": "🇮🇷",
      "code": "IR",
      "dial_code": " 98"
    },
    {
      "name": "Iraq",
      "flag": "🇮🇶",
      "code": "IQ",
      "dial_code": " 964"
    },
    {
      "name": "Ireland",
      "flag": "🇮🇪",
      "code": "IE",
      "dial_code": " 353"
    },
    {
      "name": "Isle of Man",
      "flag": "🇮🇲",
      "code": "IM",
      "dial_code": " 44"
    },
    {
      "name": "Israel",
      "flag": "🇮🇱",
      "code": "IL",
      "dial_code": " 972"
    },
    {
      "name": "Italy",
      "flag": "🇮🇹",
      "code": "IT",
      "dial_code": " 39"
    },
    {
      "name": "Jamaica",
      "flag": "🇯🇲",
      "code": "JM",
      "dial_code": " 1876"
    },
    {
      "name": "Japan",
      "flag": "🇯🇵",
      "code": "JP",
      "dial_code": " 81"
    },
    {
      "name": "Jersey",
      "flag": "🇯🇪",
      "code": "JE",
      "dial_code": " 44"
    },
    {
      "name": "Jordan",
      "flag": "🇯🇴",
      "code": "JO",
      "dial_code": " 962"
    },
    {
      "name": "Kazakhstan",
      "flag": "🇰🇿",
      "code": "KZ",
      "dial_code": " 7"
    },
    {
      "name": "Kenya",
      "flag": "🇰🇪",
      "code": "KE",
      "dial_code": " 254"
    },
    {
      "name": "Kiribati",
      "flag": "🇰🇮",
      "code": "KI",
      "dial_code": " 686"
    },
    {
      "name": "Korea, Democratic People's Republic of Korea",
      "flag": "🇰🇵",
      "code": "KP",
      "dial_code": " 850"
    },
    {
      "name": "Korea, Republic of South Korea",
      "flag": "🇰🇷",
      "code": "KR",
      "dial_code": " 82"
    },
    {
      "name": "Kosovo",
      "flag": "🇽🇰",
      "code": "XK",
      "dial_code": " 383"
    },
    {
      "name": "Kuwait",
      "flag": "🇰🇼",
      "code": "KW",
      "dial_code": " 965"
    },
    {
      "name": "Kyrgyzstan",
      "flag": "🇰🇬",
      "code": "KG",
      "dial_code": " 996"
    },
    {
      "name": "Laos",
      "flag": "🇱🇦",
      "code": "LA",
      "dial_code": " 856"
    },
    {
      "name": "Latvia",
      "flag": "🇱🇻",
      "code": "LV",
      "dial_code": " 371"
    },
    {
      "name": "Lebanon",
      "flag": "🇱🇧",
      "code": "LB",
      "dial_code": " 961"
    },
    {
      "name": "Lesotho",
      "flag": "🇱🇸",
      "code": "LS",
      "dial_code": " 266"
    },
    {
      "name": "Liberia",
      "flag": "🇱🇷",
      "code": "LR",
      "dial_code": " 231"
    },
    {
      "name": "Libyan Arab Jamahiriya",
      "flag": "🇱🇾",
      "code": "LY",
      "dial_code": " 218"
    },
    {
      "name": "Liechtenstein",
      "flag": "🇱🇮",
      "code": "LI",
      "dial_code": " 423"
    },
    {
      "name": "Lithuania",
      "flag": "🇱🇹",
      "code": "LT",
      "dial_code": " 370"
    },
    {
      "name": "Luxembourg",
      "flag": "🇱🇺",
      "code": "LU",
      "dial_code": " 352"
    },
    {
      "name": "Macao",
      "flag": "🇲🇴",
      "code": "MO",
      "dial_code": " 853"
    },
    {
      "name": "Macedonia",
      "flag": "🇲🇰",
      "code": "MK",
      "dial_code": " 389"
    },
    {
      "name": "Madagascar",
      "flag": "🇲🇬",
      "code": "MG",
      "dial_code": " 261"
    },
    {
      "name": "Malawi",
      "flag": "🇲🇼",
      "code": "MW",
      "dial_code": " 265"
    },
    {
      "name": "Malaysia",
      "flag": "🇲🇾",
      "code": "MY",
      "dial_code": " 60"
    },
    {
      "name": "Maldives",
      "flag": "🇲🇻",
      "code": "MV",
      "dial_code": " 960"
    },
    {
      "name": "Mali",
      "flag": "🇲🇱",
      "code": "ML",
      "dial_code": " 223"
    },
    {
      "name": "Malta",
      "flag": "🇲🇹",
      "code": "MT",
      "dial_code": " 356"
    },
    {
      "name": "Marshall Islands",
      "flag": "🇲🇭",
      "code": "MH",
      "dial_code": " 692"
    },
    {
      "name": "Martinique",
      "flag": "🇲🇶",
      "code": "MQ",
      "dial_code": " 596"
    },
    {
      "name": "Mauritania",
      "flag": "🇲🇷",
      "code": "MR",
      "dial_code": " 222"
    },
    {
      "name": "Mauritius",
      "flag": "🇲🇺",
      "code": "MU",
      "dial_code": " 230"
    },
    {
      "name": "Mayotte",
      "flag": "🇾🇹",
      "code": "YT",
      "dial_code": " 262"
    },
    {
      "name": "Mexico",
      "flag": "🇲🇽",
      "code": "MX",
      "dial_code": " 52"
    },
    {
      "name": "Micronesia, Federated States of Micronesia",
      "flag": "🇫🇲",
      "code": "FM",
      "dial_code": " 691"
    },
    {
      "name": "Moldova",
      "flag": "🇲🇩",
      "code": "MD",
      "dial_code": " 373"
    },
    {
      "name": "Monaco",
      "flag": "🇲🇨",
      "code": "MC",
      "dial_code": " 377"
    },
    {
      "name": "Mongolia",
      "flag": "🇲🇳",
      "code": "MN",
      "dial_code": " 976"
    },
    {
      "name": "Montenegro",
      "flag": "🇲🇪",
      "code": "ME",
      "dial_code": " 382"
    },
    {
      "name": "Montserrat",
      "flag": "🇲🇸",
      "code": "MS",
      "dial_code": " 1664"
    },
    {
      "name": "Morocco",
      "flag": "🇲🇦",
      "code": "MA",
      "dial_code": " 212"
    },
    {
      "name": "Mozambique",
      "flag": "🇲🇿",
      "code": "MZ",
      "dial_code": " 258"
    },
    {
      "name": "Myanmar",
      "flag": "🇲🇲",
      "code": "MM",
      "dial_code": " 95"
    },
    {
      "name": "Namibia",
      "flag": "🇳🇦",
      "code": "NA",
      "dial_code": " 264"
    },
    {
      "name": "Nauru",
      "flag": "🇳🇷",
      "code": "NR",
      "dial_code": " 674"
    },
    {
      "name": "Nepal",
      "flag": "🇳🇵",
      "code": "NP",
      "dial_code": " 977"
    },
    {
      "name": "Netherlands",
      "flag": "🇳🇱",
      "code": "NL",
      "dial_code": " 31"
    },
    {
      "name": "Netherlands Antilles",
      "flag": "",
      "code": "AN",
      "dial_code": " 599"
    },
    {
      "name": "New Caledonia",
      "flag": "🇳🇨",
      "code": "NC",
      "dial_code": " 687"
    },
    {
      "name": "New Zealand",
      "flag": "🇳🇿",
      "code": "NZ",
      "dial_code": " 64"
    },
    {
      "name": "Nicaragua",
      "flag": "🇳🇮",
      "code": "NI",
      "dial_code": " 505"
    },
    {
      "name": "Niger",
      "flag": "🇳🇪",
      "code": "NE",
      "dial_code": " 227"
    },
    {
      "name": "Nigeria",
      "flag": "🇳🇬",
      "code": "NG",
      "dial_code": " 234"
    },
    {
      "name": "Niue",
      "flag": "🇳🇺",
      "code": "NU",
      "dial_code": " 683"
    },
    {
      "name": "Norfolk Island",
      "flag": "🇳🇫",
      "code": "NF",
      "dial_code": " 672"
    },
    {
      "name": "Northern Mariana Islands",
      "flag": "🇲🇵",
      "code": "MP",
      "dial_code": " 1670"
    },
    {
      "name": "Norway",
      "flag": "🇳🇴",
      "code": "NO",
      "dial_code": " 47"
    },
    {
      "name": "Oman",
      "flag": "🇴🇲",
      "code": "OM",
      "dial_code": " 968"
    },
    {
      "name": "Pakistan",
      "flag": "🇵🇰",
      "code": "PK",
      "dial_code": " 92"
    },
    {
      "name": "Palau",
      "flag": "🇵🇼",
      "code": "PW",
      "dial_code": " 680"
    },
    {
      "name": "Palestinian Territory, Occupied",
      "flag": "🇵🇸",
      "code": "PS",
      "dial_code": " 970"
    },
    {
      "name": "Panama",
      "flag": "🇵🇦",
      "code": "PA",
      "dial_code": " 507"
    },
    {
      "name": "Papua New Guinea",
      "flag": "🇵🇬",
      "code": "PG",
      "dial_code": " 675"
    },
    {
      "name": "Paraguay",
      "flag": "🇵🇾",
      "code": "PY",
      "dial_code": " 595"
    },
    {
      "name": "Peru",
      "flag": "🇵🇪",
      "code": "PE",
      "dial_code": " 51"
    },
    {
      "name": "Philippines",
      "flag": "🇵🇭",
      "code": "PH",
      "dial_code": " 63"
    },
    {
      "name": "Pitcairn",
      "flag": "🇵🇳",
      "code": "PN",
      "dial_code": " 64"
    },
    {
      "name": "Poland",
      "flag": "🇵🇱",
      "code": "PL",
      "dial_code": " 48"
    },
    {
      "name": "Portugal",
      "flag": "🇵🇹",
      "code": "PT",
      "dial_code": " 351"
    },
    {
      "name": "Puerto Rico",
      "flag": "🇵🇷",
      "code": "PR",
      "dial_code": " 1939"
    },
    {
      "name": "Qatar",
      "flag": "🇶🇦",
      "code": "QA",
      "dial_code": " 974"
    },
    {
      "name": "Romania",
      "flag": "🇷🇴",
      "code": "RO",
      "dial_code": " 40"
    },
    {
      "name": "Russia",
      "flag": "🇷🇺",
      "code": "RU",
      "dial_code": " 7"
    },
    {
      "name": "Rwanda",
      "flag": "🇷🇼",
      "code": "RW",
      "dial_code": " 250"
    },
    {
      "name": "Reunion",
      "flag": "🇷🇪",
      "code": "RE",
      "dial_code": " 262"
    },
    {
      "name": "Saint Barthelemy",
      "flag": "🇧🇱",
      "code": "BL",
      "dial_code": " 590"
    },
    {
      "name": "Saint Helena, Ascension and Tristan Da Cunha",
      "flag": "🇸🇭",
      "code": "SH",
      "dial_code": " 290"
    },
    {
      "name": "Saint Kitts and Nevis",
      "flag": "🇰🇳",
      "code": "KN",
      "dial_code": " 1869"
    },
    {
      "name": "Saint Lucia",
      "flag": "🇱🇨",
      "code": "LC",
      "dial_code": " 1758"
    },
    {
      "name": "Saint Martin",
      "flag": "🇲🇫",
      "code": "MF",
      "dial_code": " 590"
    },
    {
      "name": "Saint Pierre and Miquelon",
      "flag": "🇵🇲",
      "code": "PM",
      "dial_code": " 508"
    },
    {
      "name": "Saint Vincent and the Grenadines",
      "flag": "🇻🇨",
      "code": "VC",
      "dial_code": " 1784"
    },
    {
      "name": "Samoa",
      "flag": "🇼🇸",
      "code": "WS",
      "dial_code": " 685"
    },
    {
      "name": "San Marino",
      "flag": "🇸🇲",
      "code": "SM",
      "dial_code": " 378"
    },
    {
      "name": "Sao Tome and Principe",
      "flag": "🇸🇹",
      "code": "ST",
      "dial_code": " 239"
    },
    {
      "name": "Saudi Arabia",
      "flag": "🇸🇦",
      "code": "SA",
      "dial_code": " 966"
    },
    {
      "name": "Senegal",
      "flag": "🇸🇳",
      "code": "SN",
      "dial_code": " 221"
    },
    {
      "name": "Serbia",
      "flag": "🇷🇸",
      "code": "RS",
      "dial_code": " 381"
    },
    {
      "name": "Seychelles",
      "flag": "🇸🇨",
      "code": "SC",
      "dial_code": " 248"
    },
    {
      "name": "Sierra Leone",
      "flag": "🇸🇱",
      "code": "SL",
      "dial_code": " 232"
    },
    {
      "name": "Singapore",
      "flag": "🇸🇬",
      "code": "SG",
      "dial_code": " 65"
    },
    {
      "name": "Slovakia",
      "flag": "🇸🇰",
      "code": "SK",
      "dial_code": " 421"
    },
    {
      "name": "Slovenia",
      "flag": "🇸🇮",
      "code": "SI",
      "dial_code": " 386"
    },
    {
      "name": "Solomon Islands",
      "flag": "🇸🇧",
      "code": "SB",
      "dial_code": " 677"
    },
    {
      "name": "Somalia",
      "flag": "🇸🇴",
      "code": "SO",
      "dial_code": " 252"
    },
    {
      "name": "South Africa",
      "flag": "🇿🇦",
      "code": "ZA",
      "dial_code": " 27"
    },
    {
      "name": "South Sudan",
      "flag": "🇸🇸",
      "code": "SS",
      "dial_code": " 211"
    },
    {
      "name": "South Georgia and the South Sandwich Islands",
      "flag": "🇬🇸",
      "code": "GS",
      "dial_code": " 500"
    },
    {
      "name": "Spain",
      "flag": "🇪🇸",
      "code": "ES",
      "dial_code": " 34"
    },
    {
      "name": "Sri Lanka",
      "flag": "🇱🇰",
      "code": "LK",
      "dial_code": " 94"
    },
    {
      "name": "Sudan",
      "flag": "🇸🇩",
      "code": "SD",
      "dial_code": " 249"
    },
    {
      "name": "Suriname",
      "flag": "🇸🇷",
      "code": "SR",
      "dial_code": " 597"
    },
    {
      "name": "Svalbard and Jan Mayen",
      "flag": "🇸🇯",
      "code": "SJ",
      "dial_code": " 47"
    },
    {
      "name": "Swaziland",
      "flag": "🇸🇿",
      "code": "SZ",
      "dial_code": " 268"
    },
    {
      "name": "Sweden",
      "flag": "🇸🇪",
      "code": "SE",
      "dial_code": " 46"
    },
    {
      "name": "Switzerland",
      "flag": "🇨🇭",
      "code": "CH",
      "dial_code": " 41"
    },
    {
      "name": "Syrian Arab Republic",
      "flag": "🇸🇾",
      "code": "SY",
      "dial_code": " 963"
    },
    {
      "name": "Taiwan",
      "flag": "🇹🇼",
      "code": "TW",
      "dial_code": " 886"
    },
    {
      "name": "Tajikistan",
      "flag": "🇹🇯",
      "code": "TJ",
      "dial_code": " 992"
    },
    {
      "name": "Tanzania, United Republic of Tanzania",
      "flag": "🇹🇿",
      "code": "TZ",
      "dial_code": " 255"
    },
    {
      "name": "Thailand",
      "flag": "🇹🇭",
      "code": "TH",
      "dial_code": " 66"
    },
    {
      "name": "Timor-Leste",
      "flag": "🇹🇱",
      "code": "TL",
      "dial_code": " 670"
    },
    {
      "name": "Togo",
      "flag": "🇹🇬",
      "code": "TG",
      "dial_code": " 228"
    },
    {
      "name": "Tokelau",
      "flag": "🇹🇰",
      "code": "TK",
      "dial_code": " 690"
    },
    {
      "name": "Tonga",
      "flag": "🇹🇴",
      "code": "TO",
      "dial_code": " 676"
    },
    {
      "name": "Trinidad and Tobago",
      "flag": "🇹🇹",
      "code": "TT",
      "dial_code": " 1868"
    },
    {
      "name": "Tunisia",
      "flag": "🇹🇳",
      "code": "TN",
      "dial_code": " 216"
    },
    {
      "name": "Turkey",
      "flag": "🇹🇷",
      "code": "TR",
      "dial_code": " 90"
    },
    {
      "name": "Turkmenistan",
      "flag": "🇹🇲",
      "code": "TM",
      "dial_code": " 993"
    },
    {
      "name": "Turks and Caicos Islands",
      "flag": "🇹🇨",
      "code": "TC",
      "dial_code": " 1649"
    },
    {
      "name": "Tuvalu",
      "flag": "🇹🇻",
      "code": "TV",
      "dial_code": " 688"
    },
    {
      "name": "Uganda",
      "flag": "🇺🇬",
      "code": "UG",
      "dial_code": " 256"
    },
    {
      "name": "Ukraine",
      "flag": "🇺🇦",
      "code": "UA",
      "dial_code": " 380"
    },
    {
      "name": "United Arab Emirates",
      "flag": "🇦🇪",
      "code": "AE",
      "dial_code": " 971"
    },
    {
      "name": "United Kingdom",
      "flag": "🇬🇧",
      "code": "GB",
      "dial_code": " 44"
    },
    {
      "name": "United States",
      "flag": "🇺🇸",
      "code": "US",
      "dial_code": " 1"
    },
    {
      "name": "Uruguay",
      "flag": "🇺🇾",
      "code": "UY",
      "dial_code": " 598"
    },
    {
      "name": "Uzbekistan",
      "flag": "🇺🇿",
      "code": "UZ",
      "dial_code": " 998"
    },
    {
      "name": "Vanuatu",
      "flag": "🇻🇺",
      "code": "VU",
      "dial_code": " 678"
    },
    {
      "name": "Venezuela",
      "flag": "🇻🇪",
      "code": "VE",
      "dial_code": " 58"
    },
    {
      "name": "Vietnam",
      "flag": "🇻🇳",
      "code": "VN",
      "dial_code": " 84"
    },
    {
      "name": "Virgin Islands, British",
      "flag": "🇻🇬",
      "code": "VG",
      "dial_code": " 1284"
    },
    {
      "name": "Virgin Islands, U.S.",
      "flag": "🇻🇮",
      "code": "VI",
      "dial_code": " 1340"
    },
    {
      "name": "Wallis and Futuna",
      "flag": "🇼🇫",
      "code": "WF",
      "dial_code": " 681"
    },
    {
      "name": "Yemen",
      "flag": "🇾🇪",
      "code": "YE",
      "dial_code": " 967"
    },
    {
      "name": "Zambia",
      "flag": "🇿🇲",
      "code": "ZM",
      "dial_code": " 260"
    },
    {
      "name": "Zimbabwe",
      "flag": "🇿🇼",
      "code": "ZW",
      "dial_code": " 263"
    }
  ],

  hireTeamExtensionValues: [
    { id: "Urgent (from 3-4 weeks)", name: "Urgent (from 3-4 weeks)", is_checked: 0 },
    { id: "Standard (from 4-8 weeks)", name: "Standard (from 4-8 weeks)", is_checked: 0 },
    { id: "No Rush (from 2-3 months)", name: "No Rush (from 2-3 months)", is_checked: 0 },
  ],

  getPMLeaveStatus: [
    { id: "pending", name: "Pending" },
    { id: "approved", name: "Approved" },
    { id: "rejected", name: "Rejected" },
    { id: "not_applicable", name: "Not Applicable" },
  ],
  MaritalValue: [
    { id: 'Single', value: 'Single' },
    { id: 'Married', value: 'Married' },
    { id: 'Divorced', value: 'Divorced' }
  ],
  budgetValues: [
    { id: '1', value: '10000 - 20000 USD' },
    { id: '2', value: '20000 - 50000 USD' },
    { id: '3', value: '50000 - 1M USD' },
    { id: '4', value: '1M+ USD' },
  ],
  meetingRoomBookingStatus: [
    { id: "Booked", name: "Booked" },
    { id: "Cancelled", name: "Cancelled" },
    { id: "Rejected", name: "Rejected" },
  ],
  meetingRoomBookingtype: [
    { id: "all", name: "All Bookings" },
    { id: "upcoming", name: "Upcoming Bookings" },
    { id: "past", name: "Past Bookings" },
  ],

};
export default masterData;
